import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { useDispatch, useSelector } from "react-redux"
import { injectStore } from "@/api/service"
import { api } from "./api"
import { AppSlice } from "./slices/app"
import { DevToolsSlice } from "./slices/devTools"
import { PlayerSlice, setIsAuthorized } from "./slices/player"
import { realtimeReducer } from "./slices/realtime"

export const store = configureStore({
  devTools: import.meta.env.VITE_NODE_ENV !== "production",
  reducer: {
    [api.reducerPath]: api.reducer,
    [AppSlice.name]: AppSlice.reducer,
    [PlayerSlice.name]: PlayerSlice.reducer,
    realtime: realtimeReducer,
    [DevToolsSlice.name]: DevToolsSlice.reducer
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: false
    })

    return middleware.concat(api.middleware)
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector = <T,>(cb: (state: RootState) => T) =>
  useSelector(cb)

setupListeners(store.dispatch)
injectStore(store, setIsAuthorized)
